export const codeCoverageItemAdapter = (item) => {
  item.branchCoveragePercentage = item?.branchCoverage?.percentage;
  item.statementCoveragePercentage = item?.statementCoverage?.percentage;
  return item;
};
